import { Button, Col, Row } from 'reactstrap';
import classnames from 'classnames';
import React from 'react';
import { ShiftType } from '@ms/timesheets/dist/models/shift-type';
import { ITimesheetRowState } from './timesheet-row.component';
import TimesheetEditModal from './modals/timesheet-edit-modal.component';
import 'features/pending-timesheets/styles/timesheet-row.mobile.scss';
import dayjs from 'dayjs';

const renderMobile = ({
    highlightedShiftTypes,
    timesheet,
    toggleRowSelection,
    save,
    showEditModal,
    viewEdit,
    close,
}: ITimesheetRowState): JSX.Element => (
    <div className={'mobile-timesheet-row'}>
        <Row className={'padded-row traveler-name'}>
            <Col className="table-header">
                {!timesheet.onlineApprovalDate ? (
                    <input
                        id={`select-${timesheet.timesheetId}`}
                        type="checkbox"
                        checked={timesheet.isSelected}
                        onChange={() => toggleRowSelection(timesheet)}
                        className="checkbox"
                        disabled={!!timesheet.onlineApprovalDate}
                    />
                ) : null}

                <label htmlFor={`select-${timesheet.timesheetId}`} className="m-0 cursor-pointer">
                    <span className="sr-only">Select </span>
                    {timesheet.travelerFirstName} {timesheet.travelerLastName}
                </label>
            </Col>
        </Row>

        <Row className={'padded-row'}>
            <Col className={'d-flex justify-content-start'}>
                <span className="table-header">
                    Unit Name <br />
                </span>
            </Col>
            <Col className={'d-flex justify-content-end font-weight-bold'}>{timesheet.unitName}</Col>
        </Row>
        <Row className={'padded-row'}>
            <Col
                className={classnames([
                    'd-flex',
                    'justify-content-start',
                    {
                        'font-weight-bold': highlightedShiftTypes.indexOf(ShiftType.Regular) >= 0,
                    },
                ])}
            >
                <span className="table-header">
                    Regular Hours <br />
                </span>
            </Col>
            <Col className={classnames(['d-flex', 'justify-content-end', 'font-weight-bold'])}>
                {timesheet.regularHours?.toFixed(2)}
            </Col>
        </Row>
        <Row className={'padded-row'}>
            <Col
                className={classnames([
                    'd-flex',
                    'justify-content-start',
                    {
                        'font-weight-bold': highlightedShiftTypes.indexOf(ShiftType.OnCall) >= 0,
                    },
                ])}
            >
                <span className="table-header">
                    On Call Hours <br />
                </span>
            </Col>
            <Col className={classnames(['d-flex', 'justify-content-end', 'font-weight-bold'])}>
                {timesheet.onCallHours?.toFixed(2)}
            </Col>
        </Row>
        <Row className={'padded-row'}>
            <Col
                className={classnames([
                    'd-flex',
                    'justify-content-start',
                    {
                        'font-weight-bold': highlightedShiftTypes.indexOf(ShiftType.Callback) >= 0,
                    },
                ])}
            >
                <span className="table-header">
                    Call Back Hours <br />
                </span>
            </Col>
            <Col className={classnames(['d-flex', 'justify-content-end', 'font-weight-bold'])}>
                {timesheet.callbackHours?.toFixed(2)}
            </Col>
        </Row>

        <Row className={'padded-row'}>
            <Col
                className={classnames([
                    'd-flex',
                    'justify-content-start',
                    {
                        'font-weight-bold': highlightedShiftTypes.indexOf(ShiftType.Charge) >= 0,
                    },
                ])}
            >
                <span className="table-header">
                    Charge <br />
                </span>
            </Col>
            <Col className={classnames(['d-flex', 'justify-content-end', 'font-weight-bold'])}>
                {timesheet.chargeHours?.toFixed(2)}
            </Col>
        </Row>
        <Row className={'padded-row total'}>
            <Col
                className={classnames([
                    'd-flex',
                    'justify-content-start',
                    {
                        'font-weight-bold': highlightedShiftTypes.length > 0,
                    },
                ])}
            >
                <span className="table-header">
                    Total <br />
                </span>
            </Col>
            <Col className={classnames(['d-flex', 'justify-content-end', 'font-weight-bold'])}>
                {timesheet.totalHours?.toFixed(2)}
            </Col>
        </Row>
        <Row className="justify-content-center">
            <Col className="view-edit-link d-flex justify-content-center">
                <Button color="link" onClick={() => viewEdit(timesheet)}>
                    {!timesheet?.onlineApprovalDate ? 'View / Edit' : 'View'}
                    <span className="sr-only">
                        {' '}
                        {timesheet.travelerFirstName} {timesheet.travelerLastName}'s timesheet (Opens a popup)
                    </span>
                </Button>
            </Col>
        </Row>

        {showEditModal && (
            <TimesheetEditModal
                payPeriodStart={dayjs(timesheet.payPeriodStart)}
                payPeriodEnd={dayjs(timesheet.payPeriodEnd)}
                isOpen={showEditModal}
                close={close}
                save={save}
            />
        )}
    </div>
);

export default renderMobile;
